type RequiredFields = 'email' | 'first_name' | 'last_name';

interface RemoveEmptyFieldsOptions {
    requiredFields?: RequiredFields[];
}

export function removeEmptyFields<T extends Record<string, any>>(
    obj: T,
    options: RemoveEmptyFieldsOptions = {}
): Partial<T> {
    const {requiredFields = ['email', 'first_name', 'last_name']} = options;

    return Object.fromEntries(
        Object.entries(obj).filter(([key, value]) => {
            if (requiredFields.includes(key as RequiredFields)) {
                return true;
            }
            return value !== '' && value !== null && value !== undefined;
        })
    ) as Partial<T>;
}
